import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { FormValidationModule, SwitcherModule } from '@tablesready/common-ui';
import { PartyFieldsComponent } from './party-fields.component';
import { PartyFieldsRoutingModule } from './party-fields-routing.module';
import { CustomFieldsComponent, SelectOptionsComponent } from './components';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    FrontendIconsModule,
    SwitcherModule,
    PartyFieldsRoutingModule,
    RouterModule,
    FormValidationModule,
    NgbTooltipModule,
    DragDropModule,
    FrontendDropdownModule,
    FrontendPullRefreshModule,
  ],
  declarations: [
    PartyFieldsComponent,
    CustomFieldsComponent,
    SelectOptionsComponent,
  ],
})
export class PartyFieldsModule {
}
